import React, { useState, useEffect } from 'react';
import './Informacion.css';
import axios from 'axios';
interface InformacionProps {
  nombreUsuario: string;
  correoElectronico: string;
  fotoPerfil: string | null;
  contraseñaOculta: string;
  planActual: string;
  fechaRegistro: string; // Añadir la fecha de registro
}

const Informacion: React.FC<InformacionProps> = ({
  nombreUsuario,
  correoElectronico,
  fotoPerfil,
  contraseñaOculta,
  planActual,
  fechaRegistro // Recibe la fecha de registro
}) => {
  const formattedDate = new Date(fechaRegistro).toLocaleDateString(); // Formatear la fecha

  const [error, setError] = useState('');
  const [nombre, setNombre] = useState(nombreUsuario);
  const [correo, setCorreo] = useState(correoElectronico);
  const [contraseñaActual, setContraseñaActual] = useState('');
  const [nuevaContraseña, setNuevaContraseña] = useState('');
  const [editando, setEditando] = useState('');
  const [nombreTemp, setNombreTemp] = useState(nombreUsuario);
  const [correoTemp, setCorreoTemp] = useState(correoElectronico);

  useEffect(() => {
    setNombre(nombreUsuario);
    setCorreo(correoElectronico);
    setNombreTemp(nombreUsuario);
    setCorreoTemp(correoElectronico);
  }, [nombreUsuario, correoElectronico]);

  const handleImageChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append('foto', file);

      try {
        const token = localStorage.getItem('token');
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

        const response = await fetch(`${backendUrl}/perfil/foto`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          body: formData
        });

        const result = await response.json();
        if (response.ok) {
          window.location.reload();
        } else {
          throw new Error(result.mensaje);
        }
      } catch (error) {
        setError('No se pudo subir la imagen.');
      }
    }
  };

  const handleSave = async (campo: string) => {
    const token = localStorage.getItem('token');
    try {
      let response;
      const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

      switch (campo) {
        case 'nombre':
          response = await axios.put(`${backendUrl}/perfil/nombre`, { nuevoNombre: nombre }, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          break;
        case 'correo':
          response = await axios.put(`${backendUrl}/perfil/correo`, { nuevoCorreo: correo }, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          break;
        case 'contraseña':
          response = await axios.put(`${backendUrl}/perfil/contraseña`, {
            contraseñaActual,
            nuevaContraseña
          }, {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });
          break;
        default:
          return;
      }
      alert(response.data.mensaje);
      setEditando('');
    } catch (error) {
      console.error('Error al actualizar:', error);
      alert('Error al actualizar');
    }
  };

  const handleCancel = (campo: string) => {
    switch (campo) {
      case 'nombre':
        setNombre(nombreTemp);
        break;
      case 'correo':
        setCorreo(correoTemp);
        break;
      case 'contraseña':
        setContraseñaActual('');
        setNuevaContraseña('');
        break;
      default:
        return;
    }
    setEditando('');
  };

  return (
    <div className="informacion-container">
      <div className="info-field">
        {fotoPerfil ? <img src={fotoPerfil} alt="Foto de perfil" className="image-field" /> : <p>No hay foto de perfil</p>}
        <input type="file" id="file-input" onChange={handleImageChange} className="entrada-archivo" />
        <label htmlFor="file-input" className="label-archivo">Cambiar Imagen</label>
      </div>

      <h2>Información Básica</h2>
      <div className="informacion-field">
        <label>Nombre:</label>
        {editando === 'nombre' ? (
          <>
            <input value={nombre} onChange={(e) => setNombre(e.target.value)} />
            <button className="edit-button" onClick={() => handleSave('nombre')}>Guardar</button>
            <button className="edit-button" onClick={() => handleCancel('nombre')}>Cancelar</button>
          </>
        ) : (
          <>
            <span>{nombre}</span>
            <button className="edit-button" onClick={() => setEditando('nombre')}>Editar</button>
          </>
        )}
      </div>

      <div className="informacion-field">
        <label>Correo Electrónico:</label>
        {editando === 'correo' ? (
          <>
            <input value={correo} onChange={(e) => setCorreo(e.target.value)} />
            <button className="edit-button" onClick={() => handleSave('correo')}>Guardar</button>
            <button className="edit-button" onClick={() => handleCancel('correo')}>Cancelar</button>
          </>
        ) : (
          <>
            <span>{correo}</span>
            <button className="edit-button" onClick={() => setEditando('correo')}>Editar</button>
          </>
        )}
      </div>

      <div className="informacion-field">
        <label>Contraseña:</label>
        {editando === 'contraseña' ? (
          <>
            <input
              type="password"
              placeholder="Contraseña Actual"
              value={contraseñaActual}
              onChange={(e) => setContraseñaActual(e.target.value)}
            />
            <input
              type="password"
              placeholder="Nueva Contraseña"
              value={nuevaContraseña}
              onChange={(e) => setNuevaContraseña(e.target.value)}
            />
            <button className="edit-button" onClick={() => handleSave('contraseña')}>Guardar</button>
            <button className="edit-button" onClick={() => handleCancel('contraseña')}>Cancelar</button>
          </>
        ) : (
          <>
            <span>{contraseñaOculta}</span>
            <button className="edit-button" onClick={() => setEditando('contraseña')}>Editar</button>
          </>
        )}
      </div>

      {/* Nueva Sección: Plan Actual */}
      <h2>Plan Actual</h2>
      <div className="informacion-field">
        <label>Plan:</label>
        <span>{planActual}</span>
      </div>

      <h3>Preguntas Frecuentes</h3>
      <div className="faq-section">
        <div className="faq-item">
          <h4>Información de la cuenta</h4>
          <p>
            Te diste de alta el <strong>{formattedDate}</strong> bajo el nombre de usuario:
            <strong> @{nombreUsuario}</strong>, dirección de correo electrónico asociada: 
            <strong> {correoElectronico}</strong> y el plan de suscripción que tienes activo:
            <strong> {planActual}</strong>. Esta sección te permite mantener tus datos actualizados
            y gestionar tus preferencias de usuario para asegurarte de que tu experiencia sea
            la mejor posible.
          </p>
        </div>
 
        <div className="faq-item">
          <h4>¿Cómo funciona la plataforma?</h4>
          <p>En nuestra plataforma, creamos contenido automatizado utilizando inteligencia artificial. Usamos herramientas como <strong>BestBanner</strong> para generar imágenes, <strong>OpenAI</strong> para crear textos automáticamente, y <strong>D-ID</strong> para la creación de avatares en video.</p>
        </div>
        <div className="faq-item">
          <h4>¿Cómo se gestionan los datos?</h4>
          <p>Protegemos y manejamos tus datos personales conforme a las regulaciones vigentes. Puedes ver más detalles en nuestra <a href="https://www.taapt.com/protecciondedatos" target="_blank">Política de Protección de Datos</a>.</p>
        </div>
        <div className="faq-item">
          <h4>¿Cómo realizo cambios en mi suscripción?</h4>
          <p>Puedes actualizar tu plan de suscripción desde la sección de "Plan Actual" en tu perfil o contactando con nuestro equipo de soporte en <a href="mailto:atencionalcliente@taapt.com">atencionalcliente@taapt.com</a>.</p>
        </div>
      </div>

      <h3>Soporte y Ayuda</h3>
      <div className="support-section">
        <div className="support-item">
          <h4>¿Necesitas asistencia?</h4>
          <p>Si tienes preguntas o necesitas ayuda, no dudes en ponerte en contacto con nuestro equipo de soporte. Puedes escribirnos a <a href="mailto:atencionalcliente@taapt.com">atencionalcliente@taapt.com</a>.</p>
        </div>
      </div>
    </div>
  );
};

export default Informacion;
